module.exports = __webpack_public_path__ + "assets/img/3638-ge.svg";